// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","primaryGreen":"#028154","customGrey":"#4b4b4b","container":"_1tN4EkcnXYMxB8CZUD1THx","selected":"_2ogX1C1AscC5fyoPWFh577","internalMarker":"_3SkdOf-8YhK8LFeHCh6Sz4"};


//////////////////
// WEBPACK FOOTER
// ./src/common/radio-bullet-marker/RadioBulletMarker.css
// module id = 437
// module chunks = 0 1 2